'use client'

import { MissionsList } from '../MissionsList'

import { Page } from '@/shared/ui/Page'

export function MissionsListPage() {
  return (
    <Page variant="default">
      <MissionsList />
    </Page>
  )
}
